<template>
  <two-sides-modal
    v-model="isDialogOpen"
    title="Historial de Pagos"
    subtitle="Historial de Pagos"
    icon="mdi-archive-arrow-down-outline"
    height="auto"
  >
    <v-row>
      <v-col cols="12" md="12">
        <payment-history-notice />
        <v-row class="mt-5">
          <v-col cols="12" md="9">
            <date-range-selector
              :min-date="minDate"
              :max-date="maxDate"
              @onClick="getHistoryByDate"
              @onReset="resetRange"
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-btn
              class="red-button"
              width="auto"
              :disabled="downloading"
              @click="exportSelected"
            >
              {{ !downloading ? 'Exportar excel' : 'Exportando excel...' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="12">
        <payment-history-table
          :items="items"
          @actionButton="validateInsertOrDelete($event)"
          @itemSelected="onItemSelected"
        />
      </v-col>
    </v-row>
    <template slot="actions-append"> </template>
  </two-sides-modal>
</template>
<script>
  import TwoSidesModal from '@/components/modals/TwoSidesModal.vue';
  import DateRangeSelector from '@/components/DateRangeSelector.vue';
  import PaymentHistoryTable from './PaymentHistoryTable.vue';
  import axios from '@/plugins/axios';
  import moment from 'moment';
  import dates from '@/mixins/dates.js';
  import saveFile from '@/mixins/saveFile';
  import accountStatusPaymentHistoryDate from '@/mixins/accountStatusPaymentHistoryDate';
  import PaymentHistoryNotice from '@/views/account_status/components/PaymentHistoryNotice.vue';
  import dateFormats from '@/core/constants/DateFormats';

  export default {
    name: 'PaymentHistoryModal',
    components: {
      TwoSidesModal,
      DateRangeSelector,
      PaymentHistoryTable,
      PaymentHistoryNotice,
    },
    mixins: [dates, saveFile, accountStatusPaymentHistoryDate],
    props: {
      value: {
        type: Boolean,
        default: true,
      },
      customerCode: { type: [String, Number], required: true },
    },
    data() {
      return {
        items: [],
        startDate: this.getValidStartDate(),
        endDate: moment().format(dateFormats.ISO_DATE), // Formatear según dateFormats
        selectedItems: [],
        downloading: false,
        maxDate: moment().endOf('year').toDate(),
      };
    },
    computed: {
      isDialogOpen: {
        set(newVal) {
          this.$emit('input', newVal);
        },
        get() {
          return this.value;
        },
      },
    },
    watch: {
      customerCode: {
        immediate: true,
        handler(val) {
          if (val) {
            this.getHistoryPayments();
          }
        },
      },
    },
    methods: {
      async getHistoryPayments(startDate, endDate) {
        // fallback to component dates
        const start = startDate || this.startDate;
        const end = endDate || this.endDate;

        // guard clause
        if (!start || !end) return;

        const formattedStart = this.formatDateYYYYMMDD(start);
        const formattedEnd = this.formatDateYYYYMMDD(end);

        try {
          const response = await axios.get('/payments/history-payment', {
            params: {
              customerCode: this.customerCode,
              startDate: formattedStart,
              endDate: formattedEnd,
            },
          });

          this.items = response.data;
          this.loader = false;
        } catch (error) {
          this.$toast.error(
            'No se pudo obtener la información del historial de pagos'
          );
        }
      },
      getHistoryByDate({ startDate, endDate }) {
        this.getHistoryPayments(startDate, endDate);
      },
      validateIsInserted() {
        return this.data.inserted;
      },
      validateInsertOrDelete(invoice) {
        !invoice.isOpen
          ? this.insertNewsObjects(invoice)
          : this.deleteNewsObjects(invoice);
      },
      insertNewsObjects(invoice) {
        if (!Array.isArray(invoice.ADICC) || invoice.ADICC.length === 0) return;

        const position = this.getPositionItem(invoice.FACTU);

        invoice.ADICC.forEach((creditNote, index) => {
          const newRow = {
            FACTU: creditNote.DOCTO, // Here we show DOCTO as FACTU
            TIPO: creditNote.TIPO,
            FEDOC: creditNote.FEDOC,
            MONPA: parseFloat(creditNote.MONTO ?? 0),
            inserted: true,
            idInvoice: invoice.FACTU,
            isChild: true,
          };

          this.items.splice(position + index + 1, 0, newRow);
        });

        this.$set(this.items[position], 'isOpen', true);
      },
      deleteNewsObjects(invoice) {
        this.items = this.items.filter(
          (item) => item.idInvoice !== invoice.FACTU
        );

        const position = this.getPositionItem(invoice.FACTU);

        if (position !== -1) {
          this.$set(this.items[position], 'isOpen', false);
        }
      },
      setPropertyIsOpen(isOpen, FACTU) {
        const position = this.getPositionItem(FACTU);
        this.$set(this.data[position], 'isOpen', isOpen);
      },
      getPositionItem(FACTU) {
        return this.items.findIndex((item) => item.FACTU === FACTU);
      },
      resetRange() {
        this.range.startDate = null;
        this.range.endDate = moment().format('YYYY/MM/DD');
      },
      onItemSelected(items) {
        this.selectedItems = items;
      },
      async exportSelected() {
        if (!this.selectedItems || this.selectedItems.length === 0) {
          this.$toast.error(
            'Debe seleccionar al menos un elemento para poder exportar.'
          );
          return false;
        }

        this.downloading = true;
        try {
          const response = await axios.post(
            '/payments/history-detail/export',
            {
              customerCode: this.customerCode,
              selectedItems: this.selectedItems,
            },
            {
              responseType: 'blob',
            }
          );
          this.saveFileToDevice(response.data, 'historial_pagos', 'xlsx');
        } catch (error) {
          this.$toast.error('No fue posible completar la descarga.');
        }
        this.downloading = false;
      },
    },
  };
</script>
